export const navLinks = [
    {
        id: 0,
        title: "home",
        icon: (
            <svg
                width="18"
                height="18"
                className="stroke-current"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.5 9L3.16667 7.33333M3.16667 7.33333L9 1.5L14.8333 7.33333M3.16667 7.33333V15.6667C3.16667 16.1269 3.53976 16.5 4 16.5H6.5M14.8333 7.33333L16.5 9M14.8333 7.33333V15.6667C14.8333 16.1269 14.4602 16.5 14 16.5H11.5M6.5 16.5C6.96024 16.5 7.33333 16.1269 7.33333 15.6667V12.3333C7.33333 11.8731 7.70643 11.5 8.16667 11.5H9.83333C10.2936 11.5 10.6667 11.8731 10.6667 12.3333V15.6667C10.6667 16.1269 11.0398 16.5 11.5 16.5M6.5 16.5H11.5"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        path: "/",
    },
    // {
    //     id: 1,
    //     title: "marketplace",
    //     icon: (
    //         <svg
    //             width="18"
    //             height="18"
    //             viewBox="0 0 18 18"
    //             className="stroke-current"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //         >
    //             <path
    //                 d="M10.25 16.5V10.25C10.25 10.0842 10.3159 9.92527 10.4331 9.80806C10.5503 9.69085 10.7093 9.625 10.875 9.625H13.375C13.5408 9.625 13.6997 9.69085 13.817 9.80806C13.9342 9.92527 14 10.0842 14 10.25V16.5M10.25 16.5H0.966679M10.25 16.5H14M14 16.5H17.0333M15.875 16.5V6.79083M2.12501 16.4992V6.79167M2.12501 6.79167C2.62503 7.07999 3.20939 7.18647 3.77897 7.09306C4.34855 6.99965 4.86828 6.71209 5.25001 6.27917C5.48443 6.54537 5.77293 6.75852 6.09626 6.90437C6.41959 7.05023 6.77031 7.12545 7.12501 7.125C7.87168 7.125 8.54168 6.7975 9.00001 6.27833C9.23435 6.54469 9.52282 6.75799 9.84615 6.90399C10.1695 7.05 10.5202 7.12534 10.875 7.125C11.6217 7.125 12.2917 6.7975 12.75 6.27833C13.1319 6.71112 13.6516 6.99852 14.2212 7.09178C14.7908 7.18504 15.3751 7.07842 15.875 6.79M2.12501 6.79C1.79337 6.59779 1.5103 6.33199 1.29763 6.01309C1.08495 5.6942 0.948343 5.33072 0.898343 4.95068C0.848342 4.57064 0.886282 4.1842 1.00924 3.82114C1.13219 3.45809 1.33688 3.12811 1.60751 2.85667L2.59835 1.86667C2.83254 1.63218 3.15027 1.50029 3.48168 1.5H14.5175C14.8489 1.50029 15.1667 1.63218 15.4008 1.86667L16.3925 2.8575C16.6638 3.12864 16.869 3.45855 16.9924 3.82171C17.1157 4.18487 17.1538 4.57154 17.1038 4.95179C17.0538 5.33205 16.9169 5.6957 16.7038 6.01459C16.4908 6.33349 16.2072 6.59909 15.875 6.79083M4.62501 13.9992H7.75001C7.91577 13.9992 8.07474 13.9333 8.19195 13.8161C8.30916 13.6989 8.37501 13.5399 8.37501 13.3742V10.25C8.37501 10.0842 8.30916 9.92527 8.19195 9.80806C8.07474 9.69085 7.91577 9.625 7.75001 9.625H4.62501C4.45925 9.625 4.30028 9.69085 4.18307 9.80806C4.06586 9.92527 4.00001 10.0842 4.00001 10.25V13.375C4.00001 13.7208 4.28001 14 4.62501 14V13.9992Z"
    //                 strokeWidth="1.5"
    //                 strokeLinecap="round"
    //                 strokeLinejoin="round"
    //             />
    //         </svg>
    //     ),
    //     path: "/page/marketplace",
    // },
    {
        id: 2,
        title: "Dashboard",
        icon: (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                className="stroke-current"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M1.33301 3.00001C1.33301 2.07954 2.0792 1.33334 2.99967 1.33334H4.66634C5.58682 1.33334 6.33301 2.07954 6.33301 3.00001V4.66668C6.33301 5.58715 5.58682 6.33334 4.66634 6.33334H2.99967C2.0792 6.33334 1.33301 5.58715 1.33301 4.66668V3.00001Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.66634 3.00001C9.66634 2.07954 10.4125 1.33334 11.333 1.33334H12.9997C13.9201 1.33334 14.6663 2.07954 14.6663 3.00001V4.66668C14.6663 5.58715 13.9201 6.33334 12.9997 6.33334H11.333C10.4125 6.33334 9.66634 5.58715 9.66634 4.66668V3.00001Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.33301 11.3333C1.33301 10.4129 2.0792 9.66668 2.99967 9.66668H4.66634C5.58682 9.66668 6.33301 10.4129 6.33301 11.3333V13C6.33301 13.9205 5.58682 14.6667 4.66634 14.6667H2.99967C2.0792 14.6667 1.33301 13.9205 1.33301 13V11.3333Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.66634 11.3333C9.66634 10.4129 10.4125 9.66668 11.333 9.66668H12.9997C13.9201 9.66668 14.6663 10.4129 14.6663 11.3333V13C14.6663 13.9205 13.9201 14.6667 12.9997 14.6667H11.333C10.4125 14.6667 9.66634 13.9205 9.66634 13V11.3333Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        path: "/page/dashboard",
    },
    // {
    //     id: 3,
    //     title: "starred",
    //     icon: (
    //         <svg
    //             width="18"
    //             height="17"
    //             viewBox="0 0 18 17"
    //             className="stroke-current"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //         >
    //             <path
    //                 d="M8.04896 1.92664C8.34833 1.00537 9.65167 1.00538 9.95104 1.92664L11.0208 5.21864C11.1547 5.63063 11.5386 5.90957 11.9718 5.90958L15.4333 5.90971C16.402 5.90975 16.8047 7.1493 16.0211 7.71871L13.2208 9.75341C12.8703 10.008 12.7237 10.4594 12.8575 10.8714L13.927 14.1635C14.2263 15.0847 13.1719 15.8508 12.3882 15.2815L9.58775 13.247C9.23728 12.9924 8.76272 12.9924 8.41225 13.247L5.61179 15.2815C4.82809 15.8508 3.77367 15.0847 4.07297 14.1635L5.14249 10.8714C5.27634 10.4594 5.1297 10.008 4.77924 9.75341L1.97894 7.71871C1.19528 7.1493 1.59804 5.90975 2.56672 5.90971L6.02818 5.90958C6.46137 5.90957 6.8453 5.63063 6.97918 5.21864L8.04896 1.92664Z"
    //                 strokeWidth="1.5"
    //             />
    //         </svg>
    //     ),
    //     path: "/page/favorites",
    // },
    {
        id: 4,
        title: "cart",
        icon: (
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                className="stroke-current"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M0.875 1.5H2.03C2.455 1.5 2.82583 1.78583 2.93583 2.19583L3.255 3.39333M5.25 10.875C4.58696 10.875 3.95107 11.1384 3.48223 11.6072C3.01339 12.0761 2.75 12.712 2.75 13.375H15.875M5.25 10.875H14.5983C15.5325 8.95833 16.3483 6.97167 17.035 4.92667C12.5349 3.77929 7.8972 3.26324 3.255 3.39333M5.25 10.875L3.255 3.39333M4 15.875C4 16.0408 3.93415 16.1997 3.81694 16.3169C3.69973 16.4342 3.54076 16.5 3.375 16.5C3.20924 16.5 3.05027 16.4342 2.93306 16.3169C2.81585 16.1997 2.75 16.0408 2.75 15.875C2.75 15.7092 2.81585 15.5503 2.93306 15.4331C3.05027 15.3158 3.20924 15.25 3.375 15.25C3.54076 15.25 3.69973 15.3158 3.81694 15.4331C3.93415 15.5503 4 15.7092 4 15.875V15.875ZM14.625 15.875C14.625 16.0408 14.5592 16.1997 14.4419 16.3169C14.3247 16.4342 14.1658 16.5 14 16.5C13.8342 16.5 13.6753 16.4342 13.5581 16.3169C13.4408 16.1997 13.375 16.0408 13.375 15.875C13.375 15.7092 13.4408 15.5503 13.5581 15.4331C13.6753 15.3158 13.8342 15.25 14 15.25C14.1658 15.25 14.3247 15.3158 14.4419 15.4331C14.5592 15.5503 14.625 15.7092 14.625 15.875V15.875Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        path: "/page/cart",
    },
    {
        id: 5,
        title: "manage order",
        icon: (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                className="stroke-current"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.99967 3.00001V1.33334M7.99967 3.00001C7.0792 3.00001 6.33301 3.7462 6.33301 4.66668C6.33301 5.58715 7.0792 6.33334 7.99967 6.33334M7.99967 3.00001C8.92015 3.00001 9.66634 3.7462 9.66634 4.66668C9.66634 5.58715 8.92015 6.33334 7.99967 6.33334M2.99967 13C3.92015 13 4.66634 12.2538 4.66634 11.3333C4.66634 10.4129 3.92015 9.66668 2.99967 9.66668M2.99967 13C2.0792 13 1.33301 12.2538 1.33301 11.3333C1.33301 10.4129 2.0792 9.66668 2.99967 9.66668M2.99967 13V14.6667M2.99967 9.66668V1.33334M7.99967 6.33334V14.6667M12.9997 13C13.9201 13 14.6663 12.2538 14.6663 11.3333C14.6663 10.4129 13.9201 9.66668 12.9997 9.66668M12.9997 13C12.0792 13 11.333 12.2538 11.333 11.3333C11.333 10.4129 12.0792 9.66668 12.9997 9.66668M12.9997 13V14.6667M12.9997 9.66668V1.33334"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        path: "/page/order",
    },
    // {
    //     id: 6,
    //     title: "subscription",
    //     icon: (
    //         <svg
    //             width="18"
    //             height="18"
    //             viewBox="0 0 18 18"
    //             className="stroke-current"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //         >
    //             <path
    //                 d="M14.8333 8.16667H3.16667M14.8333 8.16667C15.7538 8.16667 16.5 8.91286 16.5 9.83333V14.8333C16.5 15.7538 15.7538 16.5 14.8333 16.5H3.16667C2.24619 16.5 1.5 15.7538 1.5 14.8333V9.83333C1.5 8.91286 2.24619 8.16667 3.16667 8.16667M14.8333 8.16667V6.5C14.8333 5.57953 14.0871 4.83333 13.1667 4.83333M3.16667 8.16667V6.5C3.16667 5.57953 3.91286 4.83333 4.83333 4.83333M4.83333 4.83333V3.16667C4.83333 2.24619 5.57953 1.5 6.5 1.5H11.5C12.4205 1.5 13.1667 2.24619 13.1667 3.16667V4.83333M4.83333 4.83333H13.1667"
    //                 strokeWidth="1.26316"
    //                 strokeLinecap="round"
    //                 strokeLinejoin="round"
    //             />
    //         </svg>
    //     ),
    //     dropdownArrow: (
    //         <svg
    //             width="12"
    //             height="7"
    //             className="stroke-current"
    //             viewBox="0 0 12 7"
    //             fill="none"
    //             xmlns="http://www.w3.org/2000/svg"
    //         >
    //             <path
    //                 d="M10.6673 6L6.00065 1.33333L1.33398 6"
    //                 strokeWidth="1.5"
    //                 strokeLinecap="round"
    //                 strokeLinejoin="round"
    //             />
    //         </svg>
    //     ),
    //     path: "#",
    //     subMenu: [
    //         {
    //             id: 0,
    //             subPath: "/page/subscription",
    //             subTitle: "My subscriptions",
    //             subIcon: (
    //                 <svg
    //                     width="20"
    //                     height="20"
    //                     className="stroke-current"
    //                     viewBox="0 0 20 20"
    //                     fill="none"
    //                     xmlns="http://www.w3.org/2000/svg"
    //                 >
    //                     <path
    //                         d="M1.69743 10.2683C1.63992 10.0955 1.63992 9.90867 1.69743 9.73583C2.85326 6.25833 6.1341 3.75 10.0008 3.75C13.8658 3.75 17.1449 6.25583 18.3033 9.73167C18.3616 9.90417 18.3616 10.0908 18.3033 10.2642C17.1483 13.7417 13.8674 16.25 10.0008 16.25C6.13576 16.25 2.8566 13.7442 1.69826 10.2683H1.69743Z"
    //                         strokeLinecap="round"
    //                         strokeWidth="1.5"
    //                         strokeLinejoin="round"
    //                     />
    //                     <path
    //                         d="M12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5C9.33696 12.5 8.70107 12.2366 8.23223 11.7678C7.76339 11.2989 7.5 10.663 7.5 10C7.5 9.33696 7.76339 8.70107 8.23223 8.23223C8.70107 7.76339 9.33696 7.5 10 7.5C10.663 7.5 11.2989 7.76339 11.7678 8.23223C12.2366 8.70107 12.5 9.33696 12.5 10V10Z"
    //                         strokeWidth="1.5"
    //                         strokeLinecap="round"
    //                         strokeLinejoin="round"
    //                     />
    //                 </svg>
    //             ),
    //         },
    //         {
    //             id: 1,
    //             subPath: "/page/manage-subscription",
    //             subTitle: "Set Subscription",
    //             subIcon: (
    //                 <svg
    //                     width="18"
    //                     height="18"
    //                     className="stroke-current"
    //                     viewBox="0 0 18 18"
    //                     fill="none"
    //                     xmlns="http://www.w3.org/2000/svg"
    //                 >
    //                     <path
    //                         d="M17.1244 4.62485C17.1244 5.14431 17.0165 5.65812 16.8076 6.13369C16.5986 6.60927 16.2931 7.03624 15.9105 7.38755C15.5278 7.73886 15.0764 8.00684 14.5847 8.1745C14.0931 8.34216 13.5719 8.40585 13.0544 8.36152C12.1577 8.28569 11.1677 8.42069 10.596 9.11485L4.63603 16.3515C4.44803 16.5807 4.21412 16.768 3.94936 16.9013C3.68461 17.0346 3.39487 17.111 3.09881 17.1256C2.80274 17.1401 2.50691 17.0926 2.23034 16.9859C1.95377 16.8792 1.70261 16.7158 1.493 16.5062C1.2834 16.2966 1.12001 16.0454 1.01334 15.7689C0.906669 15.4923 0.859089 15.1965 0.873661 14.9004C0.888233 14.6043 0.964634 14.3146 1.09795 14.0499C1.23126 13.7851 1.41853 13.5512 1.6477 13.3632L8.88437 7.40319C9.57853 6.83152 9.71353 5.84152 9.6377 4.94485C9.58175 4.29333 9.69715 3.6385 9.97244 3.04535C10.2477 2.4522 10.6733 1.94134 11.207 1.56348C11.7407 1.18561 12.364 0.953873 13.0149 0.891256C13.6658 0.82864 14.3218 0.937323 14.9177 1.20652L12.1877 3.93652C12.2933 4.39327 12.5251 4.81118 12.8566 5.14267C13.188 5.47416 13.606 5.7059 14.0627 5.81152L16.7927 3.08152C17.006 3.55235 17.1244 4.07485 17.1244 4.62485Z"
    //                         strokeWidth="1.5"
    //                         strokeLinecap="round"
    //                         strokeLinejoin="round"
    //                     />
    //                 </svg>
    //             ),
    //         },
    //     ],
    // },
    {
        id: 7,
        title: "my store",
        icon: (
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                className="stroke-current"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M10.25 16.5V10.25C10.25 10.0842 10.3159 9.92527 10.4331 9.80806C10.5503 9.69085 10.7093 9.625 10.875 9.625H13.375C13.5408 9.625 13.6997 9.69085 13.817 9.80806C13.9342 9.92527 14 10.0842 14 10.25V16.5M10.25 16.5H0.966679M10.25 16.5H14M14 16.5H17.0333M15.875 16.5V6.79083C16.2072 6.59909 16.4908 6.33349 16.7038 6.01459C16.9169 5.6957 17.0538 5.33205 17.1038 4.95179C17.1538 4.57154 17.1157 4.18487 16.9924 3.82171C16.869 3.45855 16.6638 3.12864 16.3925 2.8575L15.4008 1.86667C15.1667 1.63218 14.8489 1.50029 14.5175 1.5H3.48168C3.15027 1.50029 2.83254 1.63218 2.59835 1.86667L1.60751 2.85667C1.33688 3.12811 1.13219 3.45809 1.00924 3.82114C0.886282 4.1842 0.848342 4.57064 0.898343 4.95068C0.948343 5.33072 1.08495 5.6942 1.29763 6.01309C1.5103 6.33199 1.79337 6.59779 2.12501 6.79M2.12501 16.4992V6.79167C2.62503 7.07999 4.68075 6.17674 5.25033 6.08333C7.75033 8.16667 12.2917 6.7975 12.75 6.27833C13.1319 6.71112 13.6516 6.99852 14.2212 7.09178C14.7908 7.18504 15.3751 7.07842 15.875 6.79"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        path: "/page/store",
        role: "myStore",
    },
    {
        id: 8,
        title: "Start new video",
        icon: (
            <svg
                width="24"
                height="22"
                viewBox="0 0 20 15"
                className="stroke-current"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M13 5.5L17.5528 3.22361C18.2177 2.89116 19 3.37465 19 4.11803V10.882C19 11.6253 18.2177 12.1088 17.5528 11.7764L13 9.5M3 13.5H11C12.1046 13.5 13 12.6046 13 11.5V3.5C13 2.39543 12.1046 1.5 11 1.5H3C1.89543 1.5 1 2.39543 1 3.5V11.5C1 12.6046 1.89543 13.5 3 13.5Z"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                />
            </svg>
        ),
        path: "/page/start-new-video",
        role: "video",
    },
    {
        id: 9,
        title: "Record instant video",
        icon: (
            <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                className="stroke-current"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="12" cy="12.5" r="9.25" strokeWidth="1.5" />
                <circle cx="12" cy="12.5" r="6" fill="white" />
            </svg>
        ),
        path: "/page/instant_video",
        role: "record",
    },
];
